import { ref } from 'vue'
import { defineStore } from 'pinia'
import { message } from 'ant-design-vue'
import { getUserInfo, logout, refreshToken } from '~/server/common'

/**
 * state相当于数据（data）
 * getters相当于计算属性（computed）
 * actions相当于方法（methods）
 */
export const useUserInfoStore = defineStore('myUseUserInfoStore', {
  state: () => ({
    info: ref<any>(undefined),
    tokenGroup: ref<any>({}),
    // 楼栋报名状态， 1:已报名；0:未报名
    isSignUp: ref(''),
  }),
  getters: {
    /**
     * 返回用户信息
     */
    userInfo(state) {
      return state.info
    },
    /**
     * 返回用户令牌
     */
    accessToken(state) {
      return state.tokenGroup?.accessToken || undefined
    },
    /**
     * 返回刷新令牌
     */
    refreshToken(state) {
      return state.tokenGroup?.refreshToken || undefined
    },
    getIsSignUp: (state) => {
      const isSignUp = state.isSignUp
      if (isSignUp === '' || !isSignUp) {
        return 0
      }
      const [val, time] = isSignUp.split('|')
      if (Number.parseInt(time) > new Date().getTime()) {
        return Number.parseInt(val)
      }
      else {
        return 0
      }
    },
  },
  actions: {
    /**
     * 登录的时候或者在必要的时候设置用户信息
     * @param data
     */
    setUserInfo(data: any) {
      this.info = data || null
    },

    /**
     * 项目初始化获取用户信息
     */
    getInitUserInfo() {
      // return new Promise((resolve) => {
      /**
       * 第一步：判定用户是否已登录
       * 第二步：用户已登录没有存用户信息的情况下，获取用户信息
       */
      if (useCookie('accessToken').value) {
        /**
         * 存在accessToken过期的情况，accessToken如果过去，需要使用refreshToken刷新accessToken，如果refreshToken也过期了，需要重新登录
         */
        getUserInfo().then((res: any) => {
          const { code, dataBody = {} } = res
          if (code === 0) {
            this.setUserInfo(dataBody)
            // resolve(dataBody)
          }
          else if (code === 1602005) {
            refreshToken().then((res: any) => {
              const { code } = res
              if (code === 0) {
                this.getInitUserInfo()
              }
              else {
                /**
                 * 发现refreshToken也过期了的话，就要清理服务端的会话缓存，防止用户跳转不了登录页（服务端存在跳转登录页的时候，在用户的感知里是刷新了下页面，没有跳走，实际上是跳转了页面，服务端又给重定向回来了）
                 */
                logout()
              }
            })
          }
        })
      }
      else {
        this.info = null
        this.tokenGroup = null
      }
      // })
    },

    /**
     * 获取用户信息
     */
    getUserInfo(toLogin: boolean = false) {
      /**
       * 第一步：判定用户是否已登录，未登录的情况下，提示用户未登录，并且跳转老平台登录
       * 第二步：用户已登录没有存用户信息的情况下，获取用户信息
       */
      if (this.info) {
        return Object.assign({}, this.info, { isLogin: true })
      }
      else {
        if (toLogin) {
          message.warning('请先登录，为您自动跳转登录页')
          /**
           * 跳转到/member/mobilelogin?redirect=当前路径
           */
          setTimeout(() => {
            window.location.href = `https://member.fccs.com/login.jhtml?forwardUrl=${encodeURIComponent(window.location.href)}`
          }, 2000)
        }
        return { isLogin: false }
      }
    },

    /**
     * 登出的时候或者在必要的时候清除用户信息
     */
    clearUserInfo() {
      this.info = null
      this.tokenGroup = null
      useCookie('accessToken', { domain: '.fccs.com' }).value = null
      useCookie('refreshToken', { domain: '.fccs.com' }).value = null
      useCookie('communication', { domain: '.fccs.com' }).value = null
      useCookie('userMapCookie', { domain: '.fccs.com' }).value = null
      // 跳转至https://member.fccs.com/reg/logout.do?forwardUrl=来清除登陆缓存
      window.location.href = `https://member.fccs.com/reg/logout.do?forwardUrl=${encodeURIComponent(window.location.href)}`
    },

    /**
     * 存储用户令牌accessToken
     * 存储刷新令牌refreshToken
     */
    setToken(data: any) {
      this.tokenGroup = data
    },
    setSignUp(isSignUp: number) {
      // 报名缓存3天
      const t = 3 * 24 * 60 * 60 * 1000
      const time = new Date().getTime() + t
      this.isSignUp = `${isSignUp}|${time}`
    },
  },
  persist: {
    storage: persistedState.localStorage,
  },
})
